import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { IEditProps } from "../../../../utils/common-type";
import {
  generateFormItem,
  getTreeData,
  mapEnumToList,
} from "../../../../utils/helper";
import { CustomDialog } from "../../../common";
import { GameStatusEnum, IGame } from "./type";

const Edit = (props: IEditProps<IGame>) => {
  const { t } = useTranslation();
  const T = (name: string) => {
    return t(`GameManagement.${name}`);
  };
  return (
    <CustomDialog title={t("common.edit")} {...props}>
      <Formik
        initialValues={props.data || {}}
        onSubmit={(values, { setSubmitting }) => {
          setSubmitting(false);
        }}
      >
        {(form) => (
          <Form style={{ width: "100%" }}>
            {generateFormItem(
              form,
              [
                {
                  type: "text",
                  name: "gameID",
                  label: "gameID",
                  size: { xs: 12 },
                },
                {
                  type: "text",
                  name: "gameName",
                  label: "gameName",
                  size: { xs: 12 },
                },
                {
                  type: "content",
                  name: "description",
                  label: "description",
                  size: { xs: 12 },
                },
                {
                  type: "number",
                  name: "imageURL",
                  label: "imageURL",
                  size: { xs: 12 },
                },
                {
                  type: "text",
                  name: "url",
                  label: "url",
                  size: { xs: 12 },
                },
                // TODO: 遊戲參數待討論
                {
                  type: "number",
                  name: "gameParameter",
                  label: "gameParameter",
                  disable: true,
                  size: { xs: 12 },
                },
                {
                  type: "singleSelect",
                  name: "lobbyStatus",
                  label: "lobbyStatus",
                  size: { xs: 12 },
                  treeData: getTreeData(mapEnumToList(GameStatusEnum), false),
                },
                {
                  type: "singleSelect",
                  name: "clubStatus",
                  label: "clubStatus",
                  size: { xs: 12 },
                  treeData: getTreeData(mapEnumToList(GameStatusEnum), false),
                },
              ],
              props.data,
              T
            )}
          </Form>
        )}
      </Formik>
    </CustomDialog>
  );
};
export default Edit;
